
let Sign_off =  <svg
xmlns="http://www.w3.org/2000/svg"
width="36"
height="36"
viewBox="0 0 36 36"
fill="none"
>
<path
  d="M0.527344 13.3489V34.0686L26.1635 34.7709V24.7095L11.2383 12.2954H1.58088C0.999048 12.2954 0.527344 12.7671 0.527344 13.3489Z"
  fill="#F6BD3D"
/>
<path
  d="M11.2383 12.3662V21.5092C13.5731 21.5092 14.2576 22.7618 16.8572 22.7618V12.3662H11.2383Z"
  fill="white"
/>
<path
  d="M26.5146 12.2954H15.5229C15.4649 12.7541 15.4349 13.2216 15.4349 13.6961C15.4349 19.4561 19.8375 24.1871 25.4611 24.7095V33.015C25.4611 33.5969 24.9894 34.0686 24.4076 34.0686H0.527344V34.4197C0.527344 35.0016 0.999048 35.4733 1.58088 35.4733H2.63442L6.67299 34.7709L10.7116 35.4733H26.5146C27.0965 35.4733 27.5682 35.0016 27.5682 34.4197V13.3489C27.5682 12.7671 27.0965 12.2954 26.5146 12.2954Z"
  fill="#F6BD3D"
/>
<path
  d="M10.0095 34.7709L9.30718 24.5867H2.63477V34.0685L10.0095 34.7709Z"
  fill="white"
/>
<path
  d="M9.30718 24.5867V33.5418C9.30718 33.8327 9.07133 34.0685 8.78041 34.0685H2.63477V35.4732H10.7119V24.5867H9.30718Z"
  fill="#DDEBFD"
/>
<path
  d="M34.3989 10.5355C34.3989 7.92811 33.7251 5.37876 31.2849 2.93855C29.3939 1.42946 26.9977 0.526855 24.3903 0.526855C18.2808 0.526855 13.3281 5.47954 13.3281 11.589C13.3281 14.1964 14.2307 16.5926 15.7398 18.4836C18.086 20.8298 20.7294 21.5976 23.3367 21.5976C29.4462 21.5976 34.3989 16.645 34.3989 10.5355Z"
  fill="#73C3FD"
/>
<path
  d="M31.2853 2.93848C32.7944 4.82937 33.697 7.22568 33.697 9.83305C33.697 15.9425 28.7443 20.8952 22.6348 20.8952C20.0274 20.8952 17.6312 19.9926 15.7402 18.4835C17.7672 21.0233 20.8886 22.6511 24.3907 22.6511C30.5002 22.6511 35.4529 17.6984 35.4529 11.5889C35.4529 8.08684 33.8251 4.96542 31.2853 2.93848Z"
  fill="#73C3FD"
/>
<path
  d="M22.8475 17.2924C22.5779 17.2924 22.3082 17.1896 22.1026 16.9838L17.2519 12.1331C16.8405 11.7217 16.8405 11.0547 17.2519 10.6432C17.6633 10.2318 18.3304 10.2318 18.7419 10.6432L22.8476 14.7489L30.2373 7.35912C30.6487 6.94768 31.3158 6.94768 31.7272 7.35912C32.1387 7.77056 32.1387 8.43759 31.7272 8.84903L23.5926 16.9838C23.3868 17.1895 23.1171 17.2924 22.8475 17.2924Z"
  fill="white"
/>
<path
  d="M27.5673 23.978C27.2763 23.978 27.0406 24.2139 27.0406 24.5048V34.4198C27.0406 34.7103 26.8043 34.9466 26.5138 34.9466H12.8178C12.5268 34.9466 12.291 35.1824 12.291 35.4733C12.291 35.7643 12.5268 36.0001 12.8178 36.0001H26.5138C27.3851 36.0001 28.0941 35.2912 28.0941 34.4198V24.5048C28.0941 24.2139 27.8583 23.978 27.5673 23.978Z"
  fill="#171D34"
/>
<path
  d="M10.711 24.06H2.63385C2.34286 24.06 2.10708 24.2959 2.10708 24.5868V34.9466H1.58031C1.28981 34.9466 1.05354 34.7103 1.05354 34.4198V21.09C1.05354 20.7991 0.817757 20.5632 0.52677 20.5632C0.235782 20.5632 0 20.7991 0 21.09V34.4198C0 35.2912 0.708962 36.0001 1.58031 36.0001H10.711C11.002 36.0001 11.2378 35.7643 11.2378 35.4733V24.5868C11.2378 24.2959 11.002 24.06 10.711 24.06ZM10.1842 25.1135V28.2742H3.16062V25.1135H10.1842ZM3.16062 34.9466V29.3277H10.1842V34.9466H3.16062Z"
  fill="#171D34"
/>
<path
  d="M5.79515 30.3811H4.74161C4.45063 30.3811 4.21484 30.617 4.21484 30.9079C4.21484 31.1988 4.45063 31.4346 4.74161 31.4346H5.79515C6.08614 31.4346 6.32192 31.1988 6.32192 30.9079C6.32192 30.617 6.08614 30.3811 5.79515 30.3811Z"
  fill="#171D34"
/>
<path
  d="M4.74161 27.2205H8.60459C8.89558 27.2205 9.13136 26.9847 9.13136 26.6938C9.13136 26.4028 8.89558 26.167 8.60459 26.167H4.74161C4.45063 26.167 4.21484 26.4028 4.21484 26.6938C4.21484 26.9847 4.45063 27.2205 4.74161 27.2205Z"
  fill="#171D34"
/>
<path
  d="M5.79515 32.4883H4.74161C4.45063 32.4883 4.21484 32.7241 4.21484 33.0151C4.21484 33.306 4.45063 33.5418 4.74161 33.5418H5.79515C6.08614 33.5418 6.32192 33.306 6.32192 33.0151C6.32192 32.7241 6.08614 32.4883 5.79515 32.4883Z"
  fill="#171D34"
/>
<path
  d="M8.60413 30.3811H7.90177C7.61078 30.3811 7.375 30.617 7.375 30.9079C7.375 31.1988 7.61078 31.4346 7.90177 31.4346H8.60413C8.89512 31.4346 9.1309 31.1988 9.1309 30.9079C9.1309 30.617 8.89512 30.3811 8.60413 30.3811Z"
  fill="#171D34"
/>
<path
  d="M24.3894 0C20.7991 0 17.4699 1.62393 15.2555 4.45549C15.0763 4.68467 15.1168 5.01576 15.346 5.19493C15.575 5.3741 15.9061 5.33372 16.0854 5.10447C18.0988 2.53004 21.1254 1.05354 24.3894 1.05354C30.1987 1.05354 34.9248 5.77972 34.9248 11.5889C34.9248 17.3981 30.1987 22.1243 24.3894 22.1243C18.5802 22.1243 13.854 17.3981 13.854 11.5889C13.854 9.88985 14.2459 8.26818 15.0186 6.76899C15.1519 6.51038 15.0504 6.1927 14.7918 6.0594C14.5332 5.92616 14.2156 6.02765 14.0822 6.28626C13.2437 7.91299 12.8005 9.74664 12.8005 11.5889C12.8005 11.649 12.8018 11.7088 12.8027 11.7686H1.58031C0.708962 11.7686 0 12.4775 0 13.3489V18.9828C0 19.2737 0.235782 19.5096 0.52677 19.5096C0.817757 19.5096 1.05354 19.2737 1.05354 18.9828V13.3489C1.05354 13.0585 1.28981 12.8221 1.58031 12.8221H10.711V21.5093C10.711 21.8002 10.9468 22.036 11.2378 22.036C12.2729 22.036 12.9295 22.2972 13.6898 22.5998C14.5013 22.9226 15.421 23.2886 16.8566 23.2886C17.1476 23.2886 17.3834 23.0527 17.3834 22.7618V20.8138C19.3306 22.2963 21.7588 23.1779 24.3894 23.1779C30.7796 23.1779 35.9784 17.9791 35.9784 11.5889C35.9784 5.19879 30.7796 0 24.3894 0ZM16.3299 22.2156C15.3959 22.1447 14.7535 21.8891 14.0793 21.6209C13.4081 21.3538 12.7176 21.0791 11.7645 21.0031V12.8221H12.8662C13.1603 15.5898 14.4326 18.0692 16.3299 19.9078V22.2156Z"
  fill="#171D34"
/>
<path
  d="M22.847 17.819C23.2691 17.819 23.666 17.6545 23.9644 17.3561L32.099 9.22144C32.3975 8.92294 32.5619 8.52611 32.5619 8.10399C32.5619 7.68187 32.3975 7.28504 32.0991 6.98661C31.8006 6.6881 31.4038 6.52368 30.9816 6.52368C30.5594 6.52368 30.1626 6.6881 29.8642 6.98661L22.847 14.0039L19.1138 10.2708C18.8153 9.97227 18.4185 9.80784 17.9963 9.80784C17.5741 9.80784 17.1773 9.97227 16.8789 10.2707C16.5804 10.5692 16.416 10.966 16.416 11.3882C16.416 11.8103 16.5804 12.2071 16.8789 12.5056L21.7295 17.3562C22.0279 17.6545 22.4248 17.819 22.847 17.819ZM17.4696 11.388C17.4696 11.2473 17.5243 11.1151 17.6239 11.0155C17.7233 10.916 17.8556 10.8612 17.9963 10.8612C18.137 10.8612 18.2693 10.916 18.3688 11.0155L22.4745 15.1211C22.6803 15.3268 23.0138 15.3268 23.2195 15.1211L30.6092 7.73139C30.7087 7.63186 30.841 7.57708 30.9817 7.57708C31.1224 7.57708 31.2547 7.63186 31.3542 7.73146C31.4537 7.83098 31.5085 7.96324 31.5085 8.10392C31.5085 8.2446 31.4537 8.37686 31.3542 8.47638L23.2195 16.6111C23.12 16.7106 22.9877 16.7653 22.847 16.7653C22.7063 16.7653 22.574 16.7106 22.4746 16.611L17.6239 11.7604C17.5243 11.6609 17.4696 11.5287 17.4696 11.388Z"
  fill="#171D34"
/>
</svg>

let Monthly_review_Checklist = <svg
width="36"
height="36"
viewBox="0 0 36 36"
fill="none"
xmlns="http://www.w3.org/2000/svg"
>
{" "}
<g clip-path="url(#clip0_1276_46513)">
  {" "}
  <path
    d="M34.8858 8.26637C35.4347 8.8153 35.4347 9.70511 34.8858 10.254L32.8982 12.2424L29.916 9.26024L31.9037 7.27258C32.4526 6.72294 33.3431 6.72294 33.892 7.27258L34.8858 8.26637Z"
    fill="#F6BD3D"
  />{" "}
  <path
    d="M32.8979 12.2423L30.8779 14.1984L27.9281 11.2478L27.8965 11.2155L29.9157 9.26025L32.8979 12.2423Z"
    fill="#73C3FD"
  />{" "}
  <path
    d="M24.0374 33.8841C24.0374 34.6608 23.1975 35.2898 22.4208 35.2898H2.10881C1.33214 35.2898 0.703125 34.6608 0.703125 33.8841V7.73845C0.703125 6.96178 1.33214 6.33276 2.10881 6.33276H22.4208C23.1975 6.33276 24.0374 6.96178 24.0374 7.73845V33.8841Z"
    fill="#73C3FD"
  />{" "}
  <path
    d="M21.2955 30.8127C21.2955 31.4069 20.653 31.8882 20.0588 31.8882H4.51879C3.92458 31.8882 3.44336 31.4069 3.44336 30.8127V10.8098C3.44336 10.2156 3.92458 9.73438 4.51879 9.73438H20.0587C20.6529 9.73438 21.2954 10.2156 21.2954 10.8098L21.2955 30.8127Z"
    fill="#FBFCFE"
  />{" "}
  <path
    d="M27.9281 11.2479L30.8779 14.1984L23.8973 20.9584L19.5544 25.1635L18.0637 23.6727L16.5723 22.182L21.0599 17.8356L24.0596 14.9308L27.8964 11.2156L27.9281 11.2479Z"
    fill="#307FF4"
  />{" "}
  <path
    d="M19.5549 25.1636L15.082 26.655L16.5727 22.1821L18.0642 23.6728L19.5549 25.1636Z"
    fill="#F6BD3D"
  />{" "}
  <path
    d="M17.9935 6.33296V9.3552H6.74805V6.33296C6.74805 5.55628 7.37706 4.92727 8.15373 4.92727H9.95022C9.70841 4.51186 9.55942 4.03606 9.55942 3.52158C9.55942 1.97112 10.8203 0.710205 12.3708 0.710205C13.9213 0.710205 15.1822 1.97112 15.1822 3.52158C15.1822 4.03606 15.0332 4.51186 14.7914 4.92727H16.5879C17.3645 4.92734 17.9935 5.55635 17.9935 6.33296Z"
    fill="#F6BD3D"
  />{" "}
  <path
    d="M12.3708 4.22429C12.7588 4.22429 13.0737 3.90943 13.0737 3.52145C13.0737 3.13346 12.7588 2.8186 12.3708 2.8186C11.9828 2.8186 11.668 3.13346 11.668 3.52145C11.668 3.90943 11.9828 4.22429 12.3708 4.22429Z"
    fill="#171D34"
  />{" "}
  <path
    d="M3.72433 17.297C4.11231 17.297 4.42717 16.9822 4.42717 16.5942C4.42717 16.2062 4.11231 15.8914 3.72433 15.8914C3.33634 15.8914 3.02148 16.2062 3.02148 16.5942C3.02148 16.9822 3.33641 17.297 3.72433 17.297Z"
    fill="#171D34"
  />{" "}
  <path
    d="M7.6565 15.6855C7.79375 15.8228 7.97361 15.8914 8.15347 15.8914C8.33333 15.8914 8.51326 15.8228 8.65044 15.6855L11.4618 12.8741C11.7362 12.5997 11.7362 12.1546 11.4618 11.8801C11.1874 11.6057 10.7423 11.6057 10.4678 11.8801L8.15347 14.1946L7.24475 13.2859C6.97032 13.0115 6.52524 13.0115 6.25074 13.2859C5.97631 13.5603 5.97631 14.0054 6.25074 14.2799L7.6565 15.6855Z"
    fill="#171D34"
  />{" "}
  <path
    d="M7.6565 22.7141C7.79375 22.8513 7.97361 22.92 8.15347 22.92C8.33333 22.92 8.51326 22.8513 8.65044 22.7141L11.4618 19.9027C11.7362 19.6283 11.7362 19.1832 11.4618 18.9087C11.1874 18.6343 10.7423 18.6343 10.4678 18.9087L8.15347 21.2232L7.24475 20.3145C6.97032 20.04 6.52524 20.04 6.25074 20.3145C5.97631 20.5889 5.97631 21.034 6.25074 21.3085L7.6565 22.7141Z"
    fill="#171D34"
  />{" "}
  <path
    d="M7.6565 29.7424C7.79375 29.8797 7.97361 29.9483 8.15347 29.9483C8.33333 29.9483 8.51326 29.8797 8.65044 29.7424L11.4618 26.931C11.7362 26.6566 11.7362 26.2115 11.4618 25.937C11.1874 25.6626 10.7423 25.6626 10.4678 25.937L8.15347 28.2515L7.24475 27.3428C6.97032 27.0684 6.52524 27.0684 6.25074 27.3428C5.97631 27.6172 5.97631 28.0623 6.25074 28.3368L7.6565 29.7424Z"
    fill="#171D34"
  />{" "}
  <path
    d="M13.7751 14.4858H17.9922C18.3804 14.4858 18.695 14.1711 18.695 13.7829C18.695 13.3947 18.3804 13.0801 17.9922 13.0801H13.7751C13.3869 13.0801 13.0723 13.3947 13.0723 13.7829C13.0723 14.1711 13.387 14.4858 13.7751 14.4858Z"
    fill="#171D34"
  />{" "}
  <path
    d="M36 9.26041C36 8.69728 35.7807 8.16783 35.3824 7.76965L34.389 6.7762C33.9907 6.37739 33.461 6.1578 32.8975 6.1578C32.334 6.1578 31.8043 6.37746 31.4064 6.77585L29.4225 8.75979L24.74 13.2942V7.73885C24.74 6.49622 23.5176 5.63032 22.4206 5.63032H18.5747C18.2846 4.8123 17.5033 4.22463 16.587 4.22463H15.8106C15.8595 3.99415 15.8842 3.75958 15.8842 3.52179C15.8842 1.58404 14.3077 0.00756836 12.3699 0.00756836C10.4322 0.00756836 8.85572 1.58404 8.85572 3.52179C8.85572 3.75958 8.88033 3.99415 8.92927 4.22463H8.15287C7.23663 4.22463 6.45539 4.8123 6.16521 5.63032H2.10853C0.945914 5.63018 0 6.57609 0 7.73871V33.8843C0 35.047 0.945914 35.9929 2.10853 35.9929H22.4205C23.5176 35.9929 24.7399 35.127 24.7399 33.8843V21.1204L31.191 14.8735C31.2692 14.8394 31.3425 14.791 31.4065 14.7271C31.4647 14.6689 31.5097 14.6028 31.5432 14.5325L32.8899 13.2286L33.3946 13.7333C33.5273 13.866 33.6004 14.0424 33.6004 14.2301C33.6004 14.4178 33.5273 14.5942 33.3946 14.7269L29.4186 18.7029C29.1442 18.9773 29.1442 19.4224 29.4186 19.6969C29.5559 19.8341 29.7357 19.9028 29.9156 19.9028C30.0954 19.9028 30.2754 19.8341 30.4125 19.6969L34.3885 15.7209C34.7868 15.3227 35.006 14.7932 35.006 14.2302C35.006 13.6671 34.7866 13.1376 34.3885 12.7394L33.8916 12.2425L35.3823 10.7513C35.7806 10.3529 36 9.82347 36 9.26041ZM30.8859 13.2125L28.8981 11.2242L29.9078 10.2465L31.8959 12.2346L30.8859 13.2125ZM19.5623 24.1775L17.5743 22.19L27.8882 12.2022L29.8759 14.1904L19.5623 24.1775ZM16.8795 23.4829L18.2533 24.8564L16.1928 25.5435L16.8795 23.4829ZM23.3343 7.73871V14.6553L21.7177 16.2208V9.35526C21.7177 8.96707 21.4031 8.65242 21.0149 8.65242H18.6955V7.03587H22.4205C22.8561 7.03587 23.3343 7.40367 23.3343 7.73871ZM8.15295 5.63018H9.94943C10.201 5.63018 10.4333 5.49574 10.5587 5.2777C10.6841 5.05966 10.6834 4.79121 10.5569 4.5738C10.3608 4.23701 10.2615 3.88305 10.2615 3.52165C10.2615 2.35903 11.2074 1.41312 12.37 1.41312C13.5326 1.41312 14.4785 2.35903 14.4785 3.52165C14.4785 3.88305 14.3792 4.23701 14.1832 4.5738C14.0567 4.79121 14.0559 5.05966 14.1813 5.2777C14.3068 5.49574 14.5391 5.63018 14.7906 5.63018H16.5871C16.9746 5.63018 17.2899 5.94546 17.2899 6.33302V8.65242H7.4501V6.33302C7.4501 5.94553 7.76538 5.63018 8.15295 5.63018ZM23.3343 33.8843C23.3343 34.2194 22.8561 34.5872 22.4205 34.5872H2.10853C1.72097 34.5872 1.40569 34.2719 1.40569 33.8843V7.73871C1.40569 7.35115 1.72097 7.03587 2.10853 7.03587H6.04441V8.65242H3.72502C3.33682 8.65242 3.02217 8.96707 3.02217 9.35526V13.7831C3.02217 14.1713 3.33682 14.486 3.72502 14.486C4.11321 14.486 4.42786 14.1713 4.42786 13.7831V10.0581H20.312V17.5821L17.7029 20.1087H13.7756C13.3874 20.1087 13.0728 20.4234 13.0728 20.8116C13.0728 21.1998 13.3874 21.5144 13.7756 21.5144H16.2515L16.0833 21.6772C16.0688 21.6912 16.0556 21.706 16.0426 21.7209C16.0405 21.7234 16.038 21.7256 16.0359 21.7281C16.0178 21.7494 16.0015 21.7716 15.9863 21.7945C15.9832 21.7991 15.9806 21.804 15.9775 21.8087C15.9656 21.8278 15.9545 21.8472 15.9446 21.8671C15.9415 21.8732 15.9385 21.8794 15.9356 21.8856C15.9256 21.907 15.9167 21.9288 15.909 21.951C15.908 21.9541 15.9064 21.9569 15.9054 21.96L15.9021 21.97C15.9019 21.9707 15.9017 21.9714 15.9015 21.972L14.4672 26.2754L13.5907 27.1518C13.3163 27.4263 13.3162 27.8714 13.5907 28.1458C13.728 28.283 13.9078 28.3517 14.0877 28.3517C14.2675 28.3517 14.4475 28.283 14.5846 28.1458L15.4612 27.2693L19.7767 25.8303C19.7801 25.8291 19.7831 25.8274 19.7865 25.8263C19.8084 25.8187 19.83 25.8099 19.8513 25.7999C19.8557 25.7979 19.8602 25.7961 19.8645 25.7939C19.8895 25.7817 19.9139 25.768 19.9376 25.7526C19.9395 25.7514 19.9412 25.75 19.9431 25.7487C19.9633 25.7353 19.9828 25.7206 20.0018 25.7048C20.0085 25.6993 20.0149 25.6934 20.0214 25.6877C20.0287 25.6811 20.0363 25.6752 20.0434 25.6683L20.3122 25.4081V31.5649H4.42786V19.4057C4.42786 19.0175 4.11321 18.7029 3.72502 18.7029C3.33682 18.7029 3.02217 19.0175 3.02217 19.4057V32.2677C3.02217 32.6559 3.33682 32.9706 3.72502 32.9706H21.0149C21.4031 32.9706 21.7177 32.6559 21.7177 32.2677V24.047L23.3343 22.4816V33.8843ZM34.3884 9.75731L32.8977 11.2484L30.9096 9.26034L32.4005 7.76944C32.5332 7.63654 32.7096 7.56335 32.8973 7.56335C33.0851 7.56335 33.2615 7.63654 33.3945 7.76979L34.3883 8.76358C34.521 8.89626 34.5942 9.07275 34.5942 9.26041C34.5942 9.44808 34.5212 9.62442 34.3884 9.75731Z"
    fill="#171D34"
  />{" "}
</g>{" "}
<defs>
  {" "}
  <clipPath id="clip0_1276_46513">
    {" "}
    <rect width="36" height="36" fill="white" />{" "}
  </clipPath>{" "}
</defs>{" "}
</svg>

let lets_get_started =  <svg
xmlns="http://www.w3.org/2000/svg"
width="36"
height="36"
viewBox="0 0 36 36"
fill="none"
>
<g clip-path="url(#clip0_1276_43988)">
  <path
    d="M13.695 27.6347C12.8664 28.9811 11.2251 31.0048 8.48449 31.6501L9.11393 29.5786C9.11393 29.5786 6.68392 31.196 4.34961 31.6501C4.80376 29.3078 6.42109 26.8858 6.42109 26.8858L4.34961 27.5152C4.99494 24.7746 7.01861 23.1333 8.36503 22.3048L14.1021 21.1001L13.695 27.6347Z"
    fill="#F6BD3D"
  />
  <path
    d="M22.7592 33.144C19.7657 36.1375 14.9729 36.2323 11.866 33.4297C13.0924 33.2997 14.4147 32.3242 14.5996 30.6075C14.6767 29.8944 14.5568 29.0531 14.1522 28.0911L7.90869 21.8476C6.94674 21.443 6.10537 21.3231 5.39233 21.4002C3.67565 21.5851 2.70013 22.9073 2.57012 24.1337C-0.232409 21.0269 -0.137697 16.234 2.8558 13.2405C4.62592 11.4704 7.02682 10.7141 9.33561 10.9721C10.3942 11.0905 11.4333 11.421 12.3835 11.9662L24.0335 23.6162C24.5787 24.5665 24.9098 25.6059 25.0277 26.6641C25.2856 28.9729 24.5293 31.3739 22.7592 33.144Z"
    fill="#73C3FD"
  />
  <path
    d="M14.1516 28.0912C19.0112 26.975 23.6265 24.5248 27.4123 20.7391C32.9725 15.1789 35.6527 7.82977 35.4549 0.544382C28.1695 0.346521 20.8205 3.0267 15.2603 8.5869C11.4745 12.3727 9.02428 16.9879 7.9082 21.8476L14.1516 28.0912Z"
    fill="#E3E8EC"
  />
  <path
    d="M33.83 10.6542C32.2021 9.67614 30.5876 8.42155 29.083 6.917C28.3564 6.19046 27.6888 5.43917 27.0821 4.67332C26.4316 3.8515 25.8506 3.0126 25.3438 2.17011C28.5852 0.998632 32.0029 0.456943 35.4071 0.543638C35.4232 0.544623 35.4393 0.544623 35.4549 0.545115L35.4544 0.545607C35.5472 3.96478 35.0066 7.39766 33.83 10.6542Z"
    fill="#307FF4"
  />
  <path
    d="M35.4549 0.544871L35.4544 0.545363C32.8036 1.41148 29.9568 2.80725 27.0821 4.67307C26.4316 3.85126 25.8506 3.01236 25.3438 2.16987C28.5852 0.998388 32.0029 0.456698 35.4071 0.543394C35.4232 0.544379 35.4393 0.544379 35.4549 0.544871Z"
    fill="#307FF4"
  />
  <path
    d="M23.2435 17.8899C26.0791 17.8899 28.3777 15.5913 28.3777 12.7557C28.3777 9.92023 26.0791 7.62158 23.2435 7.62158C20.408 7.62158 18.1094 9.92023 18.1094 12.7557C18.1094 15.5913 20.408 17.8899 23.2435 17.8899Z"
    fill="#307FF4"
  />
  <path
    d="M23.2445 16.2132C25.154 16.2132 26.702 14.6652 26.702 12.7558C26.702 10.8463 25.154 9.29834 23.2445 9.29834C21.3351 9.29834 19.7871 10.8463 19.7871 12.7558C19.7871 14.6652 21.3351 16.2132 23.2445 16.2132Z"
    fill="#73C3FD"
  />
  <path
    d="M35.9893 0.530012C35.9817 0.2463 35.7533 0.0178536 35.4697 0.0102598C30.9438 -0.112295 26.4327 0.864982 22.3886 2.84112C22.1197 2.97254 22.0114 3.2997 22.1481 3.56598L22.1481 3.56612C22.2809 3.82473 22.5959 3.92956 22.8572 3.80202C23.5962 3.44103 24.3517 3.11499 25.1201 2.82397C26.1093 4.40087 27.3133 5.90317 28.7047 7.29466C30.0973 8.68721 31.5998 9.89117 33.1762 10.8793C33.1489 10.9511 33.1231 11.0233 33.0952 11.0949C31.7392 14.5783 29.7001 17.696 27.0347 20.3614C23.5183 23.8779 19.1271 26.343 14.3193 27.503L8.49691 21.6806C9.65686 16.8727 12.1221 12.4816 15.6386 8.96515C17.149 7.45477 18.8265 6.13092 20.631 5.02483C20.8792 4.87267 20.9604 4.55043 20.8132 4.29927C20.6619 4.04115 20.3277 3.95692 20.0727 4.11329C18.1966 5.26333 16.4526 6.63942 14.8828 8.20929C13.9201 9.17194 13.034 10.1981 12.2277 11.2782C9.00141 9.66491 5.05538 10.2851 2.47779 12.8628C-0.704497 16.0451 -0.838232 21.1532 2.17362 24.4918C2.27662 24.6062 2.42168 24.6683 2.57053 24.6683C2.65462 24.6683 2.73991 24.6484 2.81951 24.6069C2.98031 24.523 3.08318 24.3578 3.10336 24.1776C3.18893 23.4127 3.6615 22.6903 4.33932 22.2902C5.17161 21.7989 6.25239 21.7865 7.47639 22.2508C6.02964 23.2713 4.41709 24.9148 3.8325 27.3807C3.79749 27.5282 3.82062 27.6868 3.90549 27.8123C4.04035 28.0119 4.28433 28.0937 4.50526 28.0264L5.26281 27.7963C4.74819 28.7496 4.0992 30.1455 3.82744 31.5371C3.80396 31.6575 3.81697 31.7843 3.87357 31.8932C3.98705 32.1115 4.22387 32.2188 4.45196 32.1746C5.84415 31.9038 7.24703 31.2516 8.20413 30.7354L7.9785 31.4779C7.93301 31.6276 7.94566 31.7922 8.02694 31.9259C8.12749 32.0914 8.30285 32.1844 8.48482 32.1844C8.5256 32.1844 8.56659 32.1798 8.6073 32.1701C11.0798 31.588 12.7269 29.9726 13.7491 28.5236C14.2133 29.7476 14.201 30.8284 13.7097 31.6606C13.309 32.3392 12.5855 32.8121 11.8195 32.8968C11.6547 32.915 11.5017 33.0028 11.414 33.1435C11.2724 33.3707 11.3191 33.6558 11.5081 33.8262C13.1185 35.2789 15.1403 35.9998 17.1594 35.9998C19.3263 35.9998 21.4899 35.1693 23.1371 33.522C23.3401 33.3191 23.5332 33.1054 23.7145 32.8833C23.911 32.6426 23.865 32.2863 23.6114 32.1066H23.6113C23.3809 31.9432 23.0649 31.989 22.8861 32.2078C22.7277 32.402 22.5588 32.5886 22.3813 32.7661C19.844 35.3034 15.9051 35.6219 13.0199 33.6578C13.6814 33.3539 14.2492 32.849 14.6302 32.2039C15.0709 31.4573 15.4385 30.2264 14.8635 28.4685C18.0841 27.6545 21.1193 26.2754 23.8412 24.403C24.716 26.2571 24.7797 28.3938 24.013 30.3001C23.9078 30.5618 24.0208 30.8603 24.2749 30.983L24.2752 30.9832C24.5519 31.1168 24.8868 30.9913 25.0017 30.7063C25.9071 28.4616 25.8064 25.9366 24.7228 23.7713C25.8026 22.9652 26.8284 22.0793 27.7908 21.1169C30.5615 18.3462 32.6813 15.1047 34.0915 11.4825C35.4531 7.98422 36.0918 4.2992 35.9893 0.530012ZM3.79559 21.3697C3.15033 21.7506 2.64548 22.3185 2.34159 22.9799C0.377476 20.0947 0.696063 16.1558 3.23337 13.6185C5.44435 11.4075 8.80777 10.8441 11.5966 12.1586C9.72408 14.8805 8.34497 17.9157 7.53096 21.1364C5.77314 20.5613 4.54217 20.9289 3.79559 21.3697ZM9.28892 30.8411L9.62536 29.7338C9.6909 29.5179 9.6139 29.2841 9.43285 29.1496C9.25172 29.015 9.0057 29.0086 8.81789 29.1335C8.79743 29.1472 7.00642 30.33 5.08463 30.9146C5.66851 28.9919 6.85216 27.2027 6.86566 27.1824C6.99102 26.9946 6.98484 26.7483 6.85033 26.567C6.71582 26.3857 6.48168 26.3087 6.26582 26.3742L5.15853 26.7107C5.84415 24.9574 7.14803 23.7547 8.29174 22.9869L13.0127 27.7079C12.2449 28.8516 11.0424 30.1554 9.28892 30.8411ZM33.5456 9.84772C32.1094 8.92634 30.7376 7.81568 29.4606 6.53873C28.1849 5.26312 27.0746 3.89216 26.1525 2.45616C28.969 1.51875 31.9412 1.04646 34.93 1.06966C34.9562 4.07378 34.4912 7.01862 33.5456 9.84772Z"
    fill="#171D34"
  />
  <path
    d="M19.2357 16.7638C20.3063 17.8345 21.7299 18.424 23.2439 18.424C24.758 18.424 26.1815 17.8345 27.2521 16.7638C29.4622 14.5537 29.4622 10.9575 27.2521 8.74738C26.1815 7.67673 24.758 7.08716 23.2439 7.08716C21.7298 7.08716 20.3063 7.67673 19.2357 8.74738C17.0256 10.9576 17.0256 14.5537 19.2357 16.7638ZM19.9915 9.50325C20.8602 8.63453 22.0152 8.15605 23.2439 8.15605C24.4725 8.15605 25.6276 8.63446 26.4963 9.50325C28.2897 11.2966 28.2897 14.2147 26.4963 16.008C25.6277 16.8767 24.4726 17.3552 23.2439 17.3552C22.0153 17.3552 20.8603 16.8768 19.9915 16.008C18.1981 14.2146 18.1981 11.2966 19.9915 9.50325Z"
    fill="#171D34"
  />
  <path
    d="M20.421 15.5783C21.1992 16.3565 22.2214 16.7455 23.2435 16.7455C24.2657 16.7455 25.2878 16.3565 26.066 15.5783C27.6223 14.022 27.6223 11.4898 26.066 9.93339C24.5096 8.37702 21.9774 8.37702 20.421 9.93339C18.8649 11.4897 18.8649 14.022 20.421 15.5783ZM21.177 10.6892C21.7468 10.1193 22.495 9.83453 23.2436 9.83453C23.9919 9.83453 24.7405 10.1195 25.3102 10.6892C26.4498 11.8287 26.4498 13.683 25.3102 14.8225C24.1708 15.9621 22.3164 15.9621 21.177 14.8225C20.0374 13.683 20.0374 11.8287 21.177 10.6892Z"
    fill="#171D34"
  />
</g>
<defs>
  <clipPath id="clip0_1276_43988">
    <rect width="36" height="36" fill="white" />
  </clipPath>
</defs>
</svg>

let  compiled_all_your = <svg
xmlns="http://www.w3.org/2000/svg"
width="36"
height="36"
viewBox="0 0 36 36"
fill="none"
>
<path
  d="M33.5874 35.8144H2.41211V0.185547H33.5874V35.8144ZM3.89665 34.3299H32.1028V1.67008H3.89665V34.3299Z"
  fill="#171D34"
/>
<path
  d="M6.12305 3.89697H29.8756V32.1032H6.12305V3.89697Z"
  fill="#73C3FD"
/>
<path
  d="M13.36 17.4432C16.5576 17.4432 19.1497 14.851 19.1497 11.6535C19.1497 8.4559 16.5576 5.86377 13.36 5.86377C10.1624 5.86377 7.57031 8.4559 7.57031 11.6535C7.57031 14.851 10.1624 17.4432 13.36 17.4432Z"
  fill="white"
/>
<path
  d="M13.3601 18.2226C9.76008 18.2226 6.82812 15.2907 6.82812 11.6907C6.82812 8.09065 9.76008 5.12158 13.3601 5.12158C16.9601 5.12158 19.892 8.05354 19.892 11.6535C19.892 15.2535 16.9601 18.2226 13.3601 18.2226ZM13.3601 6.60612C10.5766 6.60612 8.31266 8.87003 8.31266 11.6535C8.31266 14.437 10.5766 16.7381 13.3601 16.7381C16.1436 16.7381 18.4075 14.4742 18.4075 11.6907C18.4075 8.90715 16.1436 6.60612 13.3601 6.60612Z"
  fill="#171D34"
/>
<path
  d="M12.6191 17.4805H14.1037V19.9671H12.6191V17.4805Z"
  fill="#171D34"
/>
<path
  d="M11.541 19.9297H15.141V30.1359H11.541V19.9297Z"
  fill="#F6BD3D"
/>
<path
  d="M15.9205 30.8782H10.7988V19.1875H15.8834V30.8782H15.9205ZM12.2834 29.3937H14.3988V20.672H12.2834V29.3937Z"
  fill="#171D34"
/>
<path
  d="M22.2676 7.08862H28.5026V8.57316H22.2676V7.08862Z"
  fill="#171D34"
/>
<path
  d="M22.2676 12.1731H28.5026V13.6576H22.2676V12.1731Z"
  fill="#171D34"
/>
<path
  d="M19.8184 17.2578H28.4658V18.7423H19.8184V17.2578Z"
  fill="#171D34"
/>
<path
  d="M18.8535 22.3423H28.4659V23.8268H18.8535V22.3423Z"
  fill="#171D34"
/>
<path
  d="M18.8535 27.4268H28.4659V28.9113H18.8535V27.4268Z"
  fill="#171D34"
/>
</svg>

let Lets_clarify_some_details = <svg
xmlns="http://www.w3.org/2000/svg"
width="36"
height="36"
viewBox="0 0 36 36"
fill="none"
>
<path
  d="M33.5874 35.8144H2.41211V0.185547H33.5874V35.8144ZM3.89665 34.3299H32.1028V1.67008H3.89665V34.3299Z"
  fill="#171D34"
/>
<path
  d="M6.12305 3.89697H29.8756V32.1032H6.12305V3.89697Z"
  fill="#73C3FD"
/>
<path
  d="M13.36 17.4432C16.5576 17.4432 19.1497 14.851 19.1497 11.6535C19.1497 8.4559 16.5576 5.86377 13.36 5.86377C10.1624 5.86377 7.57031 8.4559 7.57031 11.6535C7.57031 14.851 10.1624 17.4432 13.36 17.4432Z"
  fill="white"
/>
<path
  d="M13.3601 18.2226C9.76008 18.2226 6.82812 15.2907 6.82812 11.6907C6.82812 8.09065 9.76008 5.12158 13.3601 5.12158C16.9601 5.12158 19.892 8.05354 19.892 11.6535C19.892 15.2535 16.9601 18.2226 13.3601 18.2226ZM13.3601 6.60612C10.5766 6.60612 8.31266 8.87003 8.31266 11.6535C8.31266 14.437 10.5766 16.7381 13.3601 16.7381C16.1436 16.7381 18.4075 14.4742 18.4075 11.6907C18.4075 8.90715 16.1436 6.60612 13.3601 6.60612Z"
  fill="#171D34"
/>
<path
  d="M12.6191 17.4805H14.1037V19.9671H12.6191V17.4805Z"
  fill="#171D34"
/>
<path
  d="M11.541 19.9297H15.141V30.1359H11.541V19.9297Z"
  fill="#F6BD3D"
/>
<path
  d="M15.9205 30.8782H10.7988V19.1875H15.8834V30.8782H15.9205ZM12.2834 29.3937H14.3988V20.672H12.2834V29.3937Z"
  fill="#171D34"
/>
<path
  d="M22.2676 7.08862H28.5026V8.57316H22.2676V7.08862Z"
  fill="#171D34"
/>
<path
  d="M22.2676 12.1731H28.5026V13.6576H22.2676V12.1731Z"
  fill="#171D34"
/>
<path
  d="M19.8184 17.2578H28.4658V18.7423H19.8184V17.2578Z"
  fill="#171D34"
/>
<path
  d="M18.8535 22.3423H28.4659V23.8268H18.8535V22.3423Z"
  fill="#171D34"
/>
<path
  d="M18.8535 27.4268H28.4659V28.9113H18.8535V27.4268Z"
  fill="#171D34"
/>
</svg>

let few_more_question = <svg
xmlns="http://www.w3.org/2000/svg"
width="36"
height="36"
viewBox="0 0 36 36"
fill="none"
>
<path
  d="M33.5874 35.8144H2.41211V0.185547H33.5874V35.8144ZM3.89665 34.3299H32.1028V1.67008H3.89665V34.3299Z"
  fill="#171D34"
/>
<path
  d="M6.12305 3.89697H29.8756V32.1032H6.12305V3.89697Z"
  fill="#73C3FD"
/>
<path
  d="M13.36 17.4432C16.5576 17.4432 19.1497 14.851 19.1497 11.6535C19.1497 8.4559 16.5576 5.86377 13.36 5.86377C10.1624 5.86377 7.57031 8.4559 7.57031 11.6535C7.57031 14.851 10.1624 17.4432 13.36 17.4432Z"
  fill="white"
/>
<path
  d="M13.3601 18.2226C9.76008 18.2226 6.82812 15.2907 6.82812 11.6907C6.82812 8.09065 9.76008 5.12158 13.3601 5.12158C16.9601 5.12158 19.892 8.05354 19.892 11.6535C19.892 15.2535 16.9601 18.2226 13.3601 18.2226ZM13.3601 6.60612C10.5766 6.60612 8.31266 8.87003 8.31266 11.6535C8.31266 14.437 10.5766 16.7381 13.3601 16.7381C16.1436 16.7381 18.4075 14.4742 18.4075 11.6907C18.4075 8.90715 16.1436 6.60612 13.3601 6.60612Z"
  fill="#171D34"
/>
<path
  d="M12.6191 17.4805H14.1037V19.9671H12.6191V17.4805Z"
  fill="#171D34"
/>
<path
  d="M11.541 19.9297H15.141V30.1359H11.541V19.9297Z"
  fill="#F6BD3D"
/>
<path
  d="M15.9205 30.8782H10.7988V19.1875H15.8834V30.8782H15.9205ZM12.2834 29.3937H14.3988V20.672H12.2834V29.3937Z"
  fill="#171D34"
/>
<path
  d="M22.2676 7.08862H28.5026V8.57316H22.2676V7.08862Z"
  fill="#171D34"
/>
<path
  d="M22.2676 12.1731H28.5026V13.6576H22.2676V12.1731Z"
  fill="#171D34"
/>
<path
  d="M19.8184 17.2578H28.4658V18.7423H19.8184V17.2578Z"
  fill="#171D34"
/>
<path
  d="M18.8535 22.3423H28.4659V23.8268H18.8535V22.3423Z"
  fill="#171D34"
/>
<path
  d="M18.8535 27.4268H28.4659V28.9113H18.8535V27.4268Z"
  fill="#171D34"
/>
</svg>

let generate_your_reports =  <svg
xmlns="http://www.w3.org/2000/svg"
width="36"
height="36"
viewBox="0 0 36 36"
fill="none"
>
<g clip-path="url(#clip0_1276_48518)">
  <path
    d="M23.8059 15.0967H0.580078V33.6773H23.8059V15.0967Z"
    fill="#F6BD3D"
  />
  <path
    d="M29.6125 9.29028H6.38672V27.8709H29.6125V9.29028Z"
    fill="#307FF4"
  />
  <path
    d="M35.4192 2.32251V20.9032H12.1934V2.32251H35.4192Z"
    fill="#73C3FD"
  />
  <path
    d="M30.7734 13.3549V9.87107L29.1998 9.47613C29.1766 9.41829 29.1593 9.36017 29.1301 9.30205L29.9662 7.92018L27.4985 5.45244L26.1166 6.28853C26.0585 6.25933 26.0003 6.24204 25.9425 6.21879L25.5476 4.64526H22.0637L21.6688 6.21879C21.6109 6.24204 21.5528 6.25933 21.4947 6.28853L20.1128 5.45244L17.6451 7.92018L18.4812 9.30205C18.452 9.36017 18.4347 9.41829 18.4114 9.47613L16.8379 9.87107V13.3549L18.4114 13.7499C18.4347 13.8077 18.452 13.8658 18.4812 13.924L17.6451 15.3058L20.1128 17.7736L21.4947 16.9375C21.5528 16.9667 21.6109 16.984 21.6688 17.0072L22.0637 18.5807H25.5476L25.9425 17.0072C26.0003 16.984 26.0585 16.9667 26.1166 16.9375L27.4985 17.7736L29.9662 15.3058L29.1301 13.924C29.1593 13.8658 29.1766 13.8077 29.1998 13.7499L30.7734 13.3549ZM23.8056 15.0969C21.8837 15.0969 20.3218 13.535 20.3218 11.613C20.3218 9.69104 21.8837 8.12913 23.8056 8.12913C25.7276 8.12913 27.2895 9.69104 27.2895 11.613C27.2895 13.535 25.7276 15.0969 23.8056 15.0969Z"
    fill="#F6BD3D"
  />
  <path
    d="M23.8067 15.6774C26.0479 15.6774 27.8712 13.8541 27.8712 11.6129C27.8712 9.37165 26.0479 7.54834 23.8067 7.54834C21.5655 7.54834 19.7422 9.37165 19.7422 11.6129C19.7422 13.8541 21.5655 15.6774 23.8067 15.6774ZM23.8067 8.70963C25.4074 8.70963 26.7099 10.0121 26.7099 11.6129C26.7099 13.2136 25.4074 14.5161 23.8067 14.5161C22.206 14.5161 20.9035 13.2136 20.9035 11.6129C20.9035 10.0121 22.206 8.70963 23.8067 8.70963Z"
    fill="#171D34"
  />
  <path
    d="M36 1.74194H11.6129V8.70969H5.80645V14.5161H0V34.2581H24.3871V28.4516H30.1936V21.4839H36V1.74194ZM23.2258 33.0968H1.16129V15.6774H5.80645V28.4516H23.2258V33.0968ZM29.0323 27.2903H6.96774V9.87098H11.6129V21.4839H29.0323V27.2903ZM34.8387 20.3226H12.7742V2.90323H34.8387V20.3226Z"
    fill="#171D34"
  />
  <path
    d="M16.9161 15.3981L20.0209 18.5029L21.2602 17.7589L21.6109 19.1612H26.0015L26.3516 17.7584L27.5915 18.5029L30.6963 15.3981L29.9523 14.1588L31.3546 13.8081V9.41756L29.9517 9.06741L30.6957 7.82816L27.5909 4.72335L26.3511 5.46787L26.0015 4.06445H21.6109L21.2608 5.4673L20.0215 4.72335L16.9167 7.82816L17.6607 9.06741L16.2578 9.41756V13.8081L17.6607 14.1583L16.9161 15.3981ZM17.4191 12.9014V10.3243L18.8392 9.96957L19.131 9.26021L18.3782 8.00706L20.2004 6.18489L21.4536 6.93763L22.1629 6.64589L22.5176 5.22574H25.0948L25.4495 6.64589L26.1583 6.93763L27.412 6.18489L29.2342 8.00706L28.4814 9.26021L28.7732 9.96957L30.1933 10.3243V12.9014L29.0615 13.1841L28.7516 13.3037L28.4808 13.9643L29.2336 15.2186L27.4114 17.0408L26.1577 16.2881L25.4489 16.5798L25.0948 17.9999H22.5176L22.1629 16.5798L21.4536 16.2881L20.2004 17.0408L18.3782 15.2186L19.131 13.9643L18.8407 13.2567L17.4191 12.9014Z"
    fill="#171D34"
  />
  <path
    d="M14.5156 30.7742H15.6769V31.9355H14.5156V30.7742Z"
    fill="#171D34"
  />
  <path
    d="M12.1934 30.7742H13.3546V31.9355H12.1934V30.7742Z"
    fill="#171D34"
  />
  <path
    d="M3.48356 28.4517H2.32227V31.9355H11.0319V30.7742H3.48356V28.4517Z"
    fill="#171D34"
  />
  <path
    d="M20.3223 24.9678H21.4836V26.1291H20.3223V24.9678Z"
    fill="#171D34"
  />
  <path
    d="M18 24.9678H19.1613V26.1291H18V24.9678Z"
    fill="#171D34"
  />
  <path
    d="M9.2902 22.6453H8.12891V26.1291H16.8386V24.9678H9.2902V22.6453Z"
    fill="#171D34"
  />
</g>
<defs>
  <clipPath id="clip0_1276_48518">
    <rect width="36" height="36" fill="white" />
  </clipPath>
</defs>
</svg>

let upcoming_tax_filling = <svg
xmlns="http://www.w3.org/2000/svg"
width="36"
height="36"
viewBox="0 0 36 36"
fill="none"
>
<g clip-path="url(#clip0_1276_48518)">
  <path
    d="M23.8059 15.0967H0.580078V33.6773H23.8059V15.0967Z"
    fill="#F6BD3D"
  />
  <path
    d="M29.6125 9.29028H6.38672V27.8709H29.6125V9.29028Z"
    fill="#307FF4"
  />
  <path
    d="M35.4192 2.32251V20.9032H12.1934V2.32251H35.4192Z"
    fill="#73C3FD"
  />
  <path
    d="M30.7734 13.3549V9.87107L29.1998 9.47613C29.1766 9.41829 29.1593 9.36017 29.1301 9.30205L29.9662 7.92018L27.4985 5.45244L26.1166 6.28853C26.0585 6.25933 26.0003 6.24204 25.9425 6.21879L25.5476 4.64526H22.0637L21.6688 6.21879C21.6109 6.24204 21.5528 6.25933 21.4947 6.28853L20.1128 5.45244L17.6451 7.92018L18.4812 9.30205C18.452 9.36017 18.4347 9.41829 18.4114 9.47613L16.8379 9.87107V13.3549L18.4114 13.7499C18.4347 13.8077 18.452 13.8658 18.4812 13.924L17.6451 15.3058L20.1128 17.7736L21.4947 16.9375C21.5528 16.9667 21.6109 16.984 21.6688 17.0072L22.0637 18.5807H25.5476L25.9425 17.0072C26.0003 16.984 26.0585 16.9667 26.1166 16.9375L27.4985 17.7736L29.9662 15.3058L29.1301 13.924C29.1593 13.8658 29.1766 13.8077 29.1998 13.7499L30.7734 13.3549ZM23.8056 15.0969C21.8837 15.0969 20.3218 13.535 20.3218 11.613C20.3218 9.69104 21.8837 8.12913 23.8056 8.12913C25.7276 8.12913 27.2895 9.69104 27.2895 11.613C27.2895 13.535 25.7276 15.0969 23.8056 15.0969Z"
    fill="#F6BD3D"
  />
  <path
    d="M23.8067 15.6774C26.0479 15.6774 27.8712 13.8541 27.8712 11.6129C27.8712 9.37165 26.0479 7.54834 23.8067 7.54834C21.5655 7.54834 19.7422 9.37165 19.7422 11.6129C19.7422 13.8541 21.5655 15.6774 23.8067 15.6774ZM23.8067 8.70963C25.4074 8.70963 26.7099 10.0121 26.7099 11.6129C26.7099 13.2136 25.4074 14.5161 23.8067 14.5161C22.206 14.5161 20.9035 13.2136 20.9035 11.6129C20.9035 10.0121 22.206 8.70963 23.8067 8.70963Z"
    fill="#171D34"
  />
  <path
    d="M36 1.74194H11.6129V8.70969H5.80645V14.5161H0V34.2581H24.3871V28.4516H30.1936V21.4839H36V1.74194ZM23.2258 33.0968H1.16129V15.6774H5.80645V28.4516H23.2258V33.0968ZM29.0323 27.2903H6.96774V9.87098H11.6129V21.4839H29.0323V27.2903ZM34.8387 20.3226H12.7742V2.90323H34.8387V20.3226Z"
    fill="#171D34"
  />
  <path
    d="M16.9161 15.3981L20.0209 18.5029L21.2602 17.7589L21.6109 19.1612H26.0015L26.3516 17.7584L27.5915 18.5029L30.6963 15.3981L29.9523 14.1588L31.3546 13.8081V9.41756L29.9517 9.06741L30.6957 7.82816L27.5909 4.72335L26.3511 5.46787L26.0015 4.06445H21.6109L21.2608 5.4673L20.0215 4.72335L16.9167 7.82816L17.6607 9.06741L16.2578 9.41756V13.8081L17.6607 14.1583L16.9161 15.3981ZM17.4191 12.9014V10.3243L18.8392 9.96957L19.131 9.26021L18.3782 8.00706L20.2004 6.18489L21.4536 6.93763L22.1629 6.64589L22.5176 5.22574H25.0948L25.4495 6.64589L26.1583 6.93763L27.412 6.18489L29.2342 8.00706L28.4814 9.26021L28.7732 9.96957L30.1933 10.3243V12.9014L29.0615 13.1841L28.7516 13.3037L28.4808 13.9643L29.2336 15.2186L27.4114 17.0408L26.1577 16.2881L25.4489 16.5798L25.0948 17.9999H22.5176L22.1629 16.5798L21.4536 16.2881L20.2004 17.0408L18.3782 15.2186L19.131 13.9643L18.8407 13.2567L17.4191 12.9014Z"
    fill="#171D34"
  />
  <path
    d="M14.5156 30.7742H15.6769V31.9355H14.5156V30.7742Z"
    fill="#171D34"
  />
  <path
    d="M12.1934 30.7742H13.3546V31.9355H12.1934V30.7742Z"
    fill="#171D34"
  />
  <path
    d="M3.48356 28.4517H2.32227V31.9355H11.0319V30.7742H3.48356V28.4517Z"
    fill="#171D34"
  />
  <path
    d="M20.3223 24.9678H21.4836V26.1291H20.3223V24.9678Z"
    fill="#171D34"
  />
  <path
    d="M18 24.9678H19.1613V26.1291H18V24.9678Z"
    fill="#171D34"
  />
  <path
    d="M9.2902 22.6453H8.12891V26.1291H16.8386V24.9678H9.2902V22.6453Z"
    fill="#171D34"
  />
</g>
<defs>
  <clipPath id="clip0_1276_48518">
    <rect width="36" height="36" fill="white" />
  </clipPath>
</defs>
</svg>

let generate_your_reports_Step1 =  <svg
xmlns="http://www.w3.org/2000/svg"
width="36"
height="36"
viewBox="0 0 36 36"
fill="none"
>
<path
  d="M0.527344 13.3489V34.0686L26.1635 34.7709V24.7095L11.2383 12.2954H1.58088C0.999048 12.2954 0.527344 12.7671 0.527344 13.3489Z"
  fill="#F6BD3D"
/>
<path
  d="M11.2383 12.3662V21.5092C13.5731 21.5092 14.2576 22.7618 16.8572 22.7618V12.3662H11.2383Z"
  fill="white"
/>
<path
  d="M26.5146 12.2954H15.5229C15.4649 12.7541 15.4349 13.2216 15.4349 13.6961C15.4349 19.4561 19.8375 24.1871 25.4611 24.7095V33.015C25.4611 33.5969 24.9894 34.0686 24.4076 34.0686H0.527344V34.4197C0.527344 35.0016 0.999048 35.4733 1.58088 35.4733H2.63442L6.67299 34.7709L10.7116 35.4733H26.5146C27.0965 35.4733 27.5682 35.0016 27.5682 34.4197V13.3489C27.5682 12.7671 27.0965 12.2954 26.5146 12.2954Z"
  fill="#F6BD3D"
/>
<path
  d="M10.0095 34.7709L9.30718 24.5867H2.63477V34.0685L10.0095 34.7709Z"
  fill="white"
/>
<path
  d="M9.30718 24.5867V33.5418C9.30718 33.8327 9.07133 34.0685 8.78041 34.0685H2.63477V35.4732H10.7119V24.5867H9.30718Z"
  fill="#DDEBFD"
/>
<path
  d="M34.3989 10.5355C34.3989 7.92811 33.7251 5.37876 31.2849 2.93855C29.3939 1.42946 26.9977 0.526855 24.3903 0.526855C18.2808 0.526855 13.3281 5.47954 13.3281 11.589C13.3281 14.1964 14.2307 16.5926 15.7398 18.4836C18.086 20.8298 20.7294 21.5976 23.3367 21.5976C29.4462 21.5976 34.3989 16.645 34.3989 10.5355Z"
  fill="#73C3FD"
/>
<path
  d="M31.2853 2.93848C32.7944 4.82937 33.697 7.22568 33.697 9.83305C33.697 15.9425 28.7443 20.8952 22.6348 20.8952C20.0274 20.8952 17.6312 19.9926 15.7402 18.4835C17.7672 21.0233 20.8886 22.6511 24.3907 22.6511C30.5002 22.6511 35.4529 17.6984 35.4529 11.5889C35.4529 8.08684 33.8251 4.96542 31.2853 2.93848Z"
  fill="#73C3FD"
/>
<path
  d="M22.8475 17.2924C22.5779 17.2924 22.3082 17.1896 22.1026 16.9838L17.2519 12.1331C16.8405 11.7217 16.8405 11.0547 17.2519 10.6432C17.6633 10.2318 18.3304 10.2318 18.7419 10.6432L22.8476 14.7489L30.2373 7.35912C30.6487 6.94768 31.3158 6.94768 31.7272 7.35912C32.1387 7.77056 32.1387 8.43759 31.7272 8.84903L23.5926 16.9838C23.3868 17.1895 23.1171 17.2924 22.8475 17.2924Z"
  fill="white"
/>
<path
  d="M27.5673 23.978C27.2763 23.978 27.0406 24.2139 27.0406 24.5048V34.4198C27.0406 34.7103 26.8043 34.9466 26.5138 34.9466H12.8178C12.5268 34.9466 12.291 35.1824 12.291 35.4733C12.291 35.7643 12.5268 36.0001 12.8178 36.0001H26.5138C27.3851 36.0001 28.0941 35.2912 28.0941 34.4198V24.5048C28.0941 24.2139 27.8583 23.978 27.5673 23.978Z"
  fill="#171D34"
/>
<path
  d="M10.711 24.06H2.63385C2.34286 24.06 2.10708 24.2959 2.10708 24.5868V34.9466H1.58031C1.28981 34.9466 1.05354 34.7103 1.05354 34.4198V21.09C1.05354 20.7991 0.817757 20.5632 0.52677 20.5632C0.235782 20.5632 0 20.7991 0 21.09V34.4198C0 35.2912 0.708962 36.0001 1.58031 36.0001H10.711C11.002 36.0001 11.2378 35.7643 11.2378 35.4733V24.5868C11.2378 24.2959 11.002 24.06 10.711 24.06ZM10.1842 25.1135V28.2742H3.16062V25.1135H10.1842ZM3.16062 34.9466V29.3277H10.1842V34.9466H3.16062Z"
  fill="#171D34"
/>
<path
  d="M5.79515 30.3811H4.74161C4.45063 30.3811 4.21484 30.617 4.21484 30.9079C4.21484 31.1988 4.45063 31.4346 4.74161 31.4346H5.79515C6.08614 31.4346 6.32192 31.1988 6.32192 30.9079C6.32192 30.617 6.08614 30.3811 5.79515 30.3811Z"
  fill="#171D34"
/>
<path
  d="M4.74161 27.2205H8.60459C8.89558 27.2205 9.13136 26.9847 9.13136 26.6938C9.13136 26.4028 8.89558 26.167 8.60459 26.167H4.74161C4.45063 26.167 4.21484 26.4028 4.21484 26.6938C4.21484 26.9847 4.45063 27.2205 4.74161 27.2205Z"
  fill="#171D34"
/>
<path
  d="M5.79515 32.4883H4.74161C4.45063 32.4883 4.21484 32.7241 4.21484 33.0151C4.21484 33.306 4.45063 33.5418 4.74161 33.5418H5.79515C6.08614 33.5418 6.32192 33.306 6.32192 33.0151C6.32192 32.7241 6.08614 32.4883 5.79515 32.4883Z"
  fill="#171D34"
/>
<path
  d="M8.60413 30.3811H7.90177C7.61078 30.3811 7.375 30.617 7.375 30.9079C7.375 31.1988 7.61078 31.4346 7.90177 31.4346H8.60413C8.89512 31.4346 9.1309 31.1988 9.1309 30.9079C9.1309 30.617 8.89512 30.3811 8.60413 30.3811Z"
  fill="#171D34"
/>
<path
  d="M24.3894 0C20.7991 0 17.4699 1.62393 15.2555 4.45549C15.0763 4.68467 15.1168 5.01576 15.346 5.19493C15.575 5.3741 15.9061 5.33372 16.0854 5.10447C18.0988 2.53004 21.1254 1.05354 24.3894 1.05354C30.1987 1.05354 34.9248 5.77972 34.9248 11.5889C34.9248 17.3981 30.1987 22.1243 24.3894 22.1243C18.5802 22.1243 13.854 17.3981 13.854 11.5889C13.854 9.88985 14.2459 8.26818 15.0186 6.76899C15.1519 6.51038 15.0504 6.1927 14.7918 6.0594C14.5332 5.92616 14.2156 6.02765 14.0822 6.28626C13.2437 7.91299 12.8005 9.74664 12.8005 11.5889C12.8005 11.649 12.8018 11.7088 12.8027 11.7686H1.58031C0.708962 11.7686 0 12.4775 0 13.3489V18.9828C0 19.2737 0.235782 19.5096 0.52677 19.5096C0.817757 19.5096 1.05354 19.2737 1.05354 18.9828V13.3489C1.05354 13.0585 1.28981 12.8221 1.58031 12.8221H10.711V21.5093C10.711 21.8002 10.9468 22.036 11.2378 22.036C12.2729 22.036 12.9295 22.2972 13.6898 22.5998C14.5013 22.9226 15.421 23.2886 16.8566 23.2886C17.1476 23.2886 17.3834 23.0527 17.3834 22.7618V20.8138C19.3306 22.2963 21.7588 23.1779 24.3894 23.1779C30.7796 23.1779 35.9784 17.9791 35.9784 11.5889C35.9784 5.19879 30.7796 0 24.3894 0ZM16.3299 22.2156C15.3959 22.1447 14.7535 21.8891 14.0793 21.6209C13.4081 21.3538 12.7176 21.0791 11.7645 21.0031V12.8221H12.8662C13.1603 15.5898 14.4326 18.0692 16.3299 19.9078V22.2156Z"
  fill="#171D34"
/>
<path
  d="M22.847 17.819C23.2691 17.819 23.666 17.6545 23.9644 17.3561L32.099 9.22144C32.3975 8.92294 32.5619 8.52611 32.5619 8.10399C32.5619 7.68187 32.3975 7.28504 32.0991 6.98661C31.8006 6.6881 31.4038 6.52368 30.9816 6.52368C30.5594 6.52368 30.1626 6.6881 29.8642 6.98661L22.847 14.0039L19.1138 10.2708C18.8153 9.97227 18.4185 9.80784 17.9963 9.80784C17.5741 9.80784 17.1773 9.97227 16.8789 10.2707C16.5804 10.5692 16.416 10.966 16.416 11.3882C16.416 11.8103 16.5804 12.2071 16.8789 12.5056L21.7295 17.3562C22.0279 17.6545 22.4248 17.819 22.847 17.819ZM17.4696 11.388C17.4696 11.2473 17.5243 11.1151 17.6239 11.0155C17.7233 10.916 17.8556 10.8612 17.9963 10.8612C18.137 10.8612 18.2693 10.916 18.3688 11.0155L22.4745 15.1211C22.6803 15.3268 23.0138 15.3268 23.2195 15.1211L30.6092 7.73139C30.7087 7.63186 30.841 7.57708 30.9817 7.57708C31.1224 7.57708 31.2547 7.63186 31.3542 7.73146C31.4537 7.83098 31.5085 7.96324 31.5085 8.10392C31.5085 8.2446 31.4537 8.37686 31.3542 8.47638L23.2195 16.6111C23.12 16.7106 22.9877 16.7653 22.847 16.7653C22.7063 16.7653 22.574 16.7106 22.4746 16.611L17.6239 11.7604C17.5243 11.6609 17.4696 11.5287 17.4696 11.388Z"
  fill="#171D34"
/>
</svg>

let generate_your_reports_Step2 =  <svg
xmlns="http://www.w3.org/2000/svg"
width="36"
height="36"
viewBox="0 0 36 36"
fill="none"
>
<path
  d="M0.527344 13.3489V34.0686L26.1635 34.7709V24.7095L11.2383 12.2954H1.58088C0.999048 12.2954 0.527344 12.7671 0.527344 13.3489Z"
  fill="#F6BD3D"
/>
<path
  d="M11.2383 12.3662V21.5092C13.5731 21.5092 14.2576 22.7618 16.8572 22.7618V12.3662H11.2383Z"
  fill="white"
/>
<path
  d="M26.5146 12.2954H15.5229C15.4649 12.7541 15.4349 13.2216 15.4349 13.6961C15.4349 19.4561 19.8375 24.1871 25.4611 24.7095V33.015C25.4611 33.5969 24.9894 34.0686 24.4076 34.0686H0.527344V34.4197C0.527344 35.0016 0.999048 35.4733 1.58088 35.4733H2.63442L6.67299 34.7709L10.7116 35.4733H26.5146C27.0965 35.4733 27.5682 35.0016 27.5682 34.4197V13.3489C27.5682 12.7671 27.0965 12.2954 26.5146 12.2954Z"
  fill="#F6BD3D"
/>
<path
  d="M10.0095 34.7709L9.30718 24.5867H2.63477V34.0685L10.0095 34.7709Z"
  fill="white"
/>
<path
  d="M9.30718 24.5867V33.5418C9.30718 33.8327 9.07133 34.0685 8.78041 34.0685H2.63477V35.4732H10.7119V24.5867H9.30718Z"
  fill="#DDEBFD"
/>
<path
  d="M34.3989 10.5355C34.3989 7.92811 33.7251 5.37876 31.2849 2.93855C29.3939 1.42946 26.9977 0.526855 24.3903 0.526855C18.2808 0.526855 13.3281 5.47954 13.3281 11.589C13.3281 14.1964 14.2307 16.5926 15.7398 18.4836C18.086 20.8298 20.7294 21.5976 23.3367 21.5976C29.4462 21.5976 34.3989 16.645 34.3989 10.5355Z"
  fill="#73C3FD"
/>
<path
  d="M31.2853 2.93848C32.7944 4.82937 33.697 7.22568 33.697 9.83305C33.697 15.9425 28.7443 20.8952 22.6348 20.8952C20.0274 20.8952 17.6312 19.9926 15.7402 18.4835C17.7672 21.0233 20.8886 22.6511 24.3907 22.6511C30.5002 22.6511 35.4529 17.6984 35.4529 11.5889C35.4529 8.08684 33.8251 4.96542 31.2853 2.93848Z"
  fill="#73C3FD"
/>
<path
  d="M22.8475 17.2924C22.5779 17.2924 22.3082 17.1896 22.1026 16.9838L17.2519 12.1331C16.8405 11.7217 16.8405 11.0547 17.2519 10.6432C17.6633 10.2318 18.3304 10.2318 18.7419 10.6432L22.8476 14.7489L30.2373 7.35912C30.6487 6.94768 31.3158 6.94768 31.7272 7.35912C32.1387 7.77056 32.1387 8.43759 31.7272 8.84903L23.5926 16.9838C23.3868 17.1895 23.1171 17.2924 22.8475 17.2924Z"
  fill="white"
/>
<path
  d="M27.5673 23.978C27.2763 23.978 27.0406 24.2139 27.0406 24.5048V34.4198C27.0406 34.7103 26.8043 34.9466 26.5138 34.9466H12.8178C12.5268 34.9466 12.291 35.1824 12.291 35.4733C12.291 35.7643 12.5268 36.0001 12.8178 36.0001H26.5138C27.3851 36.0001 28.0941 35.2912 28.0941 34.4198V24.5048C28.0941 24.2139 27.8583 23.978 27.5673 23.978Z"
  fill="#171D34"
/>
<path
  d="M10.711 24.06H2.63385C2.34286 24.06 2.10708 24.2959 2.10708 24.5868V34.9466H1.58031C1.28981 34.9466 1.05354 34.7103 1.05354 34.4198V21.09C1.05354 20.7991 0.817757 20.5632 0.52677 20.5632C0.235782 20.5632 0 20.7991 0 21.09V34.4198C0 35.2912 0.708962 36.0001 1.58031 36.0001H10.711C11.002 36.0001 11.2378 35.7643 11.2378 35.4733V24.5868C11.2378 24.2959 11.002 24.06 10.711 24.06ZM10.1842 25.1135V28.2742H3.16062V25.1135H10.1842ZM3.16062 34.9466V29.3277H10.1842V34.9466H3.16062Z"
  fill="#171D34"
/>
<path
  d="M5.79515 30.3811H4.74161C4.45063 30.3811 4.21484 30.617 4.21484 30.9079C4.21484 31.1988 4.45063 31.4346 4.74161 31.4346H5.79515C6.08614 31.4346 6.32192 31.1988 6.32192 30.9079C6.32192 30.617 6.08614 30.3811 5.79515 30.3811Z"
  fill="#171D34"
/>
<path
  d="M4.74161 27.2205H8.60459C8.89558 27.2205 9.13136 26.9847 9.13136 26.6938C9.13136 26.4028 8.89558 26.167 8.60459 26.167H4.74161C4.45063 26.167 4.21484 26.4028 4.21484 26.6938C4.21484 26.9847 4.45063 27.2205 4.74161 27.2205Z"
  fill="#171D34"
/>
<path
  d="M5.79515 32.4883H4.74161C4.45063 32.4883 4.21484 32.7241 4.21484 33.0151C4.21484 33.306 4.45063 33.5418 4.74161 33.5418H5.79515C6.08614 33.5418 6.32192 33.306 6.32192 33.0151C6.32192 32.7241 6.08614 32.4883 5.79515 32.4883Z"
  fill="#171D34"
/>
<path
  d="M8.60413 30.3811H7.90177C7.61078 30.3811 7.375 30.617 7.375 30.9079C7.375 31.1988 7.61078 31.4346 7.90177 31.4346H8.60413C8.89512 31.4346 9.1309 31.1988 9.1309 30.9079C9.1309 30.617 8.89512 30.3811 8.60413 30.3811Z"
  fill="#171D34"
/>
<path
  d="M24.3894 0C20.7991 0 17.4699 1.62393 15.2555 4.45549C15.0763 4.68467 15.1168 5.01576 15.346 5.19493C15.575 5.3741 15.9061 5.33372 16.0854 5.10447C18.0988 2.53004 21.1254 1.05354 24.3894 1.05354C30.1987 1.05354 34.9248 5.77972 34.9248 11.5889C34.9248 17.3981 30.1987 22.1243 24.3894 22.1243C18.5802 22.1243 13.854 17.3981 13.854 11.5889C13.854 9.88985 14.2459 8.26818 15.0186 6.76899C15.1519 6.51038 15.0504 6.1927 14.7918 6.0594C14.5332 5.92616 14.2156 6.02765 14.0822 6.28626C13.2437 7.91299 12.8005 9.74664 12.8005 11.5889C12.8005 11.649 12.8018 11.7088 12.8027 11.7686H1.58031C0.708962 11.7686 0 12.4775 0 13.3489V18.9828C0 19.2737 0.235782 19.5096 0.52677 19.5096C0.817757 19.5096 1.05354 19.2737 1.05354 18.9828V13.3489C1.05354 13.0585 1.28981 12.8221 1.58031 12.8221H10.711V21.5093C10.711 21.8002 10.9468 22.036 11.2378 22.036C12.2729 22.036 12.9295 22.2972 13.6898 22.5998C14.5013 22.9226 15.421 23.2886 16.8566 23.2886C17.1476 23.2886 17.3834 23.0527 17.3834 22.7618V20.8138C19.3306 22.2963 21.7588 23.1779 24.3894 23.1779C30.7796 23.1779 35.9784 17.9791 35.9784 11.5889C35.9784 5.19879 30.7796 0 24.3894 0ZM16.3299 22.2156C15.3959 22.1447 14.7535 21.8891 14.0793 21.6209C13.4081 21.3538 12.7176 21.0791 11.7645 21.0031V12.8221H12.8662C13.1603 15.5898 14.4326 18.0692 16.3299 19.9078V22.2156Z"
  fill="#171D34"
/>
<path
  d="M22.847 17.819C23.2691 17.819 23.666 17.6545 23.9644 17.3561L32.099 9.22144C32.3975 8.92294 32.5619 8.52611 32.5619 8.10399C32.5619 7.68187 32.3975 7.28504 32.0991 6.98661C31.8006 6.6881 31.4038 6.52368 30.9816 6.52368C30.5594 6.52368 30.1626 6.6881 29.8642 6.98661L22.847 14.0039L19.1138 10.2708C18.8153 9.97227 18.4185 9.80784 17.9963 9.80784C17.5741 9.80784 17.1773 9.97227 16.8789 10.2707C16.5804 10.5692 16.416 10.966 16.416 11.3882C16.416 11.8103 16.5804 12.2071 16.8789 12.5056L21.7295 17.3562C22.0279 17.6545 22.4248 17.819 22.847 17.819ZM17.4696 11.388C17.4696 11.2473 17.5243 11.1151 17.6239 11.0155C17.7233 10.916 17.8556 10.8612 17.9963 10.8612C18.137 10.8612 18.2693 10.916 18.3688 11.0155L22.4745 15.1211C22.6803 15.3268 23.0138 15.3268 23.2195 15.1211L30.6092 7.73139C30.7087 7.63186 30.841 7.57708 30.9817 7.57708C31.1224 7.57708 31.2547 7.63186 31.3542 7.73146C31.4537 7.83098 31.5085 7.96324 31.5085 8.10392C31.5085 8.2446 31.4537 8.37686 31.3542 8.47638L23.2195 16.6111C23.12 16.7106 22.9877 16.7653 22.847 16.7653C22.7063 16.7653 22.574 16.7106 22.4746 16.611L17.6239 11.7604C17.5243 11.6609 17.4696 11.5287 17.4696 11.388Z"
  fill="#171D34"
/>
</svg>

let generate_your_reports_Step3 =  <svg
xmlns="http://www.w3.org/2000/svg"
width="36"
height="36"
viewBox="0 0 36 36"
fill="none"
>
<g clip-path="url(#clip0_1276_48518)">
  <path
    d="M23.8059 15.0967H0.580078V33.6773H23.8059V15.0967Z"
    fill="#F6BD3D"
  />
  <path
    d="M29.6125 9.29028H6.38672V27.8709H29.6125V9.29028Z"
    fill="#307FF4"
  />
  <path
    d="M35.4192 2.32251V20.9032H12.1934V2.32251H35.4192Z"
    fill="#73C3FD"
  />
  <path
    d="M30.7734 13.3549V9.87107L29.1998 9.47613C29.1766 9.41829 29.1593 9.36017 29.1301 9.30205L29.9662 7.92018L27.4985 5.45244L26.1166 6.28853C26.0585 6.25933 26.0003 6.24204 25.9425 6.21879L25.5476 4.64526H22.0637L21.6688 6.21879C21.6109 6.24204 21.5528 6.25933 21.4947 6.28853L20.1128 5.45244L17.6451 7.92018L18.4812 9.30205C18.452 9.36017 18.4347 9.41829 18.4114 9.47613L16.8379 9.87107V13.3549L18.4114 13.7499C18.4347 13.8077 18.452 13.8658 18.4812 13.924L17.6451 15.3058L20.1128 17.7736L21.4947 16.9375C21.5528 16.9667 21.6109 16.984 21.6688 17.0072L22.0637 18.5807H25.5476L25.9425 17.0072C26.0003 16.984 26.0585 16.9667 26.1166 16.9375L27.4985 17.7736L29.9662 15.3058L29.1301 13.924C29.1593 13.8658 29.1766 13.8077 29.1998 13.7499L30.7734 13.3549ZM23.8056 15.0969C21.8837 15.0969 20.3218 13.535 20.3218 11.613C20.3218 9.69104 21.8837 8.12913 23.8056 8.12913C25.7276 8.12913 27.2895 9.69104 27.2895 11.613C27.2895 13.535 25.7276 15.0969 23.8056 15.0969Z"
    fill="#F6BD3D"
  />
  <path
    d="M23.8067 15.6774C26.0479 15.6774 27.8712 13.8541 27.8712 11.6129C27.8712 9.37165 26.0479 7.54834 23.8067 7.54834C21.5655 7.54834 19.7422 9.37165 19.7422 11.6129C19.7422 13.8541 21.5655 15.6774 23.8067 15.6774ZM23.8067 8.70963C25.4074 8.70963 26.7099 10.0121 26.7099 11.6129C26.7099 13.2136 25.4074 14.5161 23.8067 14.5161C22.206 14.5161 20.9035 13.2136 20.9035 11.6129C20.9035 10.0121 22.206 8.70963 23.8067 8.70963Z"
    fill="#171D34"
  />
  <path
    d="M36 1.74194H11.6129V8.70969H5.80645V14.5161H0V34.2581H24.3871V28.4516H30.1936V21.4839H36V1.74194ZM23.2258 33.0968H1.16129V15.6774H5.80645V28.4516H23.2258V33.0968ZM29.0323 27.2903H6.96774V9.87098H11.6129V21.4839H29.0323V27.2903ZM34.8387 20.3226H12.7742V2.90323H34.8387V20.3226Z"
    fill="#171D34"
  />
  <path
    d="M16.9161 15.3981L20.0209 18.5029L21.2602 17.7589L21.6109 19.1612H26.0015L26.3516 17.7584L27.5915 18.5029L30.6963 15.3981L29.9523 14.1588L31.3546 13.8081V9.41756L29.9517 9.06741L30.6957 7.82816L27.5909 4.72335L26.3511 5.46787L26.0015 4.06445H21.6109L21.2608 5.4673L20.0215 4.72335L16.9167 7.82816L17.6607 9.06741L16.2578 9.41756V13.8081L17.6607 14.1583L16.9161 15.3981ZM17.4191 12.9014V10.3243L18.8392 9.96957L19.131 9.26021L18.3782 8.00706L20.2004 6.18489L21.4536 6.93763L22.1629 6.64589L22.5176 5.22574H25.0948L25.4495 6.64589L26.1583 6.93763L27.412 6.18489L29.2342 8.00706L28.4814 9.26021L28.7732 9.96957L30.1933 10.3243V12.9014L29.0615 13.1841L28.7516 13.3037L28.4808 13.9643L29.2336 15.2186L27.4114 17.0408L26.1577 16.2881L25.4489 16.5798L25.0948 17.9999H22.5176L22.1629 16.5798L21.4536 16.2881L20.2004 17.0408L18.3782 15.2186L19.131 13.9643L18.8407 13.2567L17.4191 12.9014Z"
    fill="#171D34"
  />
  <path
    d="M14.5156 30.7742H15.6769V31.9355H14.5156V30.7742Z"
    fill="#171D34"
  />
  <path
    d="M12.1934 30.7742H13.3546V31.9355H12.1934V30.7742Z"
    fill="#171D34"
  />
  <path
    d="M3.48356 28.4517H2.32227V31.9355H11.0319V30.7742H3.48356V28.4517Z"
    fill="#171D34"
  />
  <path
    d="M20.3223 24.9678H21.4836V26.1291H20.3223V24.9678Z"
    fill="#171D34"
  />
  <path
    d="M18 24.9678H19.1613V26.1291H18V24.9678Z"
    fill="#171D34"
  />
  <path
    d="M9.2902 22.6453H8.12891V26.1291H16.8386V24.9678H9.2902V22.6453Z"
    fill="#171D34"
  />
</g>
<defs>
  <clipPath id="clip0_1276_48518">
    <rect width="36" height="36" fill="white" />
  </clipPath>
</defs>
</svg>



export const getSvg=(type)=>{

    switch(type){
        case "sign off" :
          return Sign_off ;
        case "Monthly review Checklist" :
          return Monthly_review_Checklist ;
        case "Lets get started" :
          return lets_get_started ;
        case 'compiled all your documents':
          return compiled_all_your ;
        case 'Lets clarify some details':
          return Lets_clarify_some_details ;
        case 'few more questions':
          return few_more_question ;
        case 'generate your reports':
          return generate_your_reports ;
        case 'Upcoming tax filing':
          return upcoming_tax_filling ;
        case 'generate your reports Step 1':
          return generate_your_reports_Step1 ;
        case 'generate your reports Step 2':
          return generate_your_reports_Step2 ;
        case 'generate your reports Step 3':
          return generate_your_reports_Step3 ;     
        default : return ""
     
    }
   

}